import CounselorSetup from 'sms/enquiry/js/CounselorSetup';
import React, { useEffect, useState } from 'react'
import { getLstExamSvc } from './ExamHeaderSvc';


const ExamDateHeader = (props) => {
    const [examId, setExamId] = useState(props.examId)
    const [lstExam, setLstExam] = useState([]);
    const [dynamicWidth, setDynamicWidth] = useState('calc(100% / ' + 9 + ')');

    useEffect(() => {
        // console.log("examDateHeader.js called");
        setExamId(props.examId)
        getLstExamSvc(cbLstExamResponse);

    }, [])

    function cbLstExamResponse(data) {
        // console.log("cbLstExamResponse called, data", data);
        if (data.SvcStatus === 'Success') {
            setLstExam(data.lstExam)
            setDynamicWidth('calc(100% / ' + data.lstExam.length + ')');
            props.examClick(data.lstExam[0])
        }
        // console.log(data)

    }
    function examClick(pExam) {
        // console.log("examClick Called, exam", pExam);
        props.examClick(pExam);
    }
    return (

        <div className="wrapper-box" style={{ height: '36px'
        , boxShadow: 'rgba(64, 60, 67, 0.16) 0px 2px 5px 1px'
        , width: '100%', marginBottom: 10 }}>
            {lstExam.map((obj) => {
                var isSelected = obj.examId === props.examId;
                return <div
                    className={isSelected ? "sellected exam-block" : "exam-block"}
                    onClick={(e) => examClick(obj)} key={obj.examId}
                    style={{ width: dynamicWidth }}>
                    <div className="exam-block text-center">
                        <span className="hidden">{obj.examId}</span>
                        <span>{obj.exam}</span>
                    </div>
                    
                </div>
            })}
        </div >

    )
}

export default ExamDateHeader